import { ErrorAccessor } from "./ErrorAccessor.js";
class EntityListAccessor {
  constructor(state, operations, _children, _idsPersistedOnServer, hasUnpersistedChanges, errors, environment, getAccessor) {
    this.state = state;
    this.operations = operations;
    this._children = _children;
    this._idsPersistedOnServer = _idsPersistedOnServer;
    this.hasUnpersistedChanges = hasUnpersistedChanges;
    this.errors = errors;
    this.environment = environment;
    this.getAccessor = getAccessor;
  }
  /**
   * Returns all entity keys that are on the list.
   * **KEYS ARE NOT IDS!**
   * @see EntityAccessor.key
   */
  *keys() {
    for (const accessor of this) {
      yield accessor.key;
    }
  }
  *ids() {
    return this._children.keys();
  }
  /**
   * This will only contain the ids that the server knows about. Not necessarily the ids that have been added on
   * the list since the last server query.
   */
  get idsPersistedOnServer() {
    return new Set(this._idsPersistedOnServer);
  }
  *[Symbol.iterator]() {
    for (const { getAccessor } of this._children.values()) {
      yield getAccessor();
    }
  }
  hasEntityId(id) {
    return this._children.has(id);
  }
  isEmpty() {
    return this.length === 0;
  }
  get length() {
    return this._children.size;
  }
  hasEntityOnServer(entityOrItsId) {
    if (typeof entityOrItsId === "string" || typeof entityOrItsId === "number") {
      return this.idsPersistedOnServer.has(entityOrItsId);
    }
    const idOnServer = entityOrItsId.idOnServer;
    if (idOnServer === void 0) {
      return false;
    }
    return this.idsPersistedOnServer.has(idOnServer);
  }
  deleteAll() {
    this.batchUpdates((getAccessor) => {
      const list = getAccessor();
      for (const entity of list) {
        entity.deleteEntity();
      }
    });
  }
  disconnectAll() {
    this.batchUpdates((getAccessor) => {
      const list = getAccessor();
      for (const entity of list) {
        list.disconnectEntity(entity);
      }
    });
  }
  addError(error) {
    return this.operations.addError(this.state, ErrorAccessor.normalizeError(error));
  }
  addEventListener(event, listener) {
    return this.operations.addEventListener(this.state, event, listener);
  }
  addChildEventListener(state, event, listener) {
    return this.operations.addChildEventListener(this.state, event, listener);
  }
  batchUpdates(performUpdates) {
    this.operations.batchUpdates(this.state, performUpdates);
  }
  connectEntity(entityToConnect) {
    this.operations.connectEntity(this.state, entityToConnect);
  }
  createNewEntity(initialize) {
    return this.operations.createNewEntity(this.state, initialize);
  }
  disconnectEntity(childEntity, options = {}) {
    this.operations.disconnectEntity(this.state, childEntity, options);
  }
  getChildEntityById(id) {
    return this.operations.getChildEntityById(this.state, id);
  }
}
export {
  EntityListAccessor
};
//# sourceMappingURL=EntityListAccessor.js.map
